/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallingIdentity } from './CallingIdentity';
import {
    CallingIdentityFromJSON,
    CallingIdentityFromJSONTyped,
    CallingIdentityToJSON,
} from './CallingIdentity';
import type { PromptQuestion } from './PromptQuestion';
import {
    PromptQuestionFromJSON,
    PromptQuestionFromJSONTyped,
    PromptQuestionToJSON,
} from './PromptQuestion';

/**
 * 
 * @export
 * @interface TestPromptForContactRequestContent
 */
export interface TestPromptForContactRequestContent {
    /**
     * The contact for which the transcript will be tested with
     * @type {string}
     * @memberof TestPromptForContactRequestContent
     */
    contactId: string;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof TestPromptForContactRequestContent
     */
    callingIdentity: CallingIdentity;
    /**
     * The import containing the contact (if any)
     * @type {string}
     * @memberof TestPromptForContactRequestContent
     */
    contactImportId?: string;
    /**
     * 
     * @type {Array<PromptQuestion>}
     * @memberof TestPromptForContactRequestContent
     */
    promptQuestions?: Array<PromptQuestion>;
}


/**
 * Check if a given object implements the TestPromptForContactRequestContent interface.
 */
export function instanceOfTestPromptForContactRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contactId" in value;
    isInstance = isInstance && "callingIdentity" in value;

    return isInstance;
}

export function TestPromptForContactRequestContentFromJSON(json: any): TestPromptForContactRequestContent {
    return TestPromptForContactRequestContentFromJSONTyped(json, false);
}

export function TestPromptForContactRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestPromptForContactRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contactId': json['contactId'],
        'callingIdentity': CallingIdentityFromJSON(json['callingIdentity']),
        'contactImportId': !exists(json, 'contactImportId') ? undefined : json['contactImportId'],
        'promptQuestions': !exists(json, 'promptQuestions') ? undefined : ((json['promptQuestions'] as Array<any>).map(PromptQuestionFromJSON)),
    };
}

export function TestPromptForContactRequestContentToJSON(value?: TestPromptForContactRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contactId': value.contactId,
        'callingIdentity': CallingIdentityToJSON(value.callingIdentity),
        'contactImportId': value.contactImportId,
        'promptQuestions': value.promptQuestions === undefined ? undefined : ((value.promptQuestions as Array<any>).map(PromptQuestionToJSON)),
    };
}

